export default async (chartOptions, payload) => {
  const importRelation = await import('../graphYAxis');
  const relation = importRelation.relation();
  let yAxisIndex = relation[payload.measurement.yAxis];
  let yAxisCount = 0;
  // removing from series
  if (payload.measurement.label === 'Ref_Flt') {
    for (let i = 0; i < chartOptions.series.length; i++) {
      if (yAxisIndex === chartOptions.series[i].yAxis) {
        yAxisCount = yAxisCount + 1;
      }
      if (chartOptions.series[i].name.includes('Ref_Flt')) {
        chartOptions.series.splice(i, 1);
        i = i - 1;
      }
    }
    if (yAxisCount === 5) {
      chartOptions.yAxis[yAxisIndex].visible = false;
    }
  } else {
    let seriesIndex = 0;
    for (let i = 0; i < chartOptions.series.length; i++) {
      if (yAxisIndex === chartOptions.series[i].yAxis) {
        yAxisCount = yAxisCount + 1;
      }
      if (chartOptions.series[i].name === payload.measurement.fullform) {
        seriesIndex = i;
      }
    }
    if (yAxisCount === 1) {
      chartOptions.yAxis[yAxisIndex].visible = false;
    }
    chartOptions.series.splice(seriesIndex, 1);
  }
};
